'use client'

import { featureFlagsAtom } from '@polaris/core/stores'
import { validateNumberInput } from '@polaris/core/utils'
import { useFieldActions, useFieldValue, useForm } from 'form-atoms'
import { useAtomValue, useSetAtom } from 'jotai'
import { type ChangeEventHandler, useCallback } from 'react'
import { Input } from '@/src/components/ui/input'
import {
  manualInsufficientBalanceForFeesErrorAtom,
  maxBalanceStateAtom,
  swapFormAtom,
} from '@/src/stores/swap/atoms'

export const FromAmountInput = () => {
  const setMaxBalanceState = useSetAtom(maxBalanceStateAtom)

  const { fieldAtoms } = useForm(swapFormAtom)
  const { setValue } = useFieldActions(fieldAtoms.fromAmount)
  const value = useFieldValue(fieldAtoms.fromAmount)
  const fromTokenValue = useFieldValue(fieldAtoms.from)
  const setManualInsufficientBalanceForFeesError = useSetAtom(
    manualInsufficientBalanceForFeesErrorAtom,
  )
  const { trading } = useAtomValue(featureFlagsAtom)

  const onChange: ChangeEventHandler<HTMLInputElement> = useCallback(
    (e) => {
      const { isValid, newValue } = validateNumberInput(e.target.value)

      if (isValid) {
        setValue(newValue)
        setMaxBalanceState('default')
        setManualInsufficientBalanceForFeesError(undefined)
      }
    },
    [setValue, setManualInsufficientBalanceForFeesError, setMaxBalanceState],
  )

  const onPasteChange: React.ClipboardEventHandler<HTMLInputElement> =
    useCallback(
      (e) => {
        const value = e.clipboardData.getData('Text')

        const { isValid, newValue } = validateNumberInput(value)

        if (isValid) setValue((+newValue).toString())
      },
      [setValue],
    )

  return (
    <div className='flex py-1 pl-3 overflow-hidden'>
      <Input
        autoScale
        onChange={onChange}
        value={value}
        disabled={!(fromTokenValue?.chain ?? false) || !trading}
        type='text'
        placeholder='0'
        variant='ghost'
        dimension='large'
        name='fromAmount'
        autoComplete='off'
        className='placeholder:text-input-placeholder text-input-text max-w-[264px] font-serif font-extralight outline-none'
        onPaste={onPasteChange}
      />
    </div>
  )
}
